import { render } from "./PermissionError.vue?vue&type=template&id=02059b99&scoped=true&ts=true"
import script from "./PermissionError.vue?vue&type=script&lang=ts"
export * from "./PermissionError.vue?vue&type=script&lang=ts"

import "./PermissionError.vue?vue&type=style&index=0&id=02059b99&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02059b99"]])

export default __exports__